import appApi from '../../../../api/app-api';

const countriesInHebrew = [
  { id: 1, name: 'אפגניסטן' },
  { id: 2, name: 'אלבניה' },
  { id: 3, name: "אלג'יריה" },
  { id: 4, name: 'אנדורה' },
  { id: 5, name: 'אנגולה' },
  { id: 6, name: 'אנטיגואה וברבודה' },
  { id: 7, name: 'ארגנטינה' },
  { id: 8, name: 'ארמניה' },
  { id: 9, name: 'אוסטרליה' },
  { id: 10, name: 'אוסטריה' },
  { id: 11, name: "אזרבייג'ן" },
  { id: 12, name: 'בהאמה' },
  { id: 13, name: 'בחריין' },
  { id: 14, name: 'בנגלדש' },
  { id: 15, name: 'ברבדוס' },
  { id: 16, name: 'בלארוס' },
  { id: 17, name: 'בלגיה' },
  { id: 18, name: 'בליז' },
  { id: 19, name: 'בנין' },
  { id: 20, name: 'בהוטן' },
  { id: 21, name: 'בוליביה' },
  { id: 22, name: 'בוסניה והרצגובינה' },
  { id: 23, name: 'בוטסואנה' },
  { id: 24, name: 'ברזיל' },
  { id: 25, name: 'ברוניי' },
  { id: 26, name: 'בולגריה' },
  { id: 27, name: 'בורקינה פאסו' },
  { id: 28, name: 'בורונדי' },
  { id: 29, name: 'קמבודיה' },
  { id: 30, name: 'קמרון' },
  { id: 31, name: 'קנדה' },
  { id: 32, name: 'כף ורדה' },
  { id: 33, name: 'הרפובליקה המרכז-אפריקאית' },
  { id: 34, name: "צ'אד" },
  { id: 35, name: "צ'ילה" },
  { id: 36, name: 'סין' },
  { id: 37, name: 'קולומביה' },
  { id: 38, name: 'קומורוס' },
  { id: 39, name: 'קונגו' },
  { id: 40, name: 'קוסטה ריקה' },
  { id: 41, name: 'חוף השנהב' },
  { id: 42, name: 'קרואטיה' },
  { id: 43, name: 'קובה' },
  { id: 44, name: 'קפריסין' },
  { id: 45, name: "צ'כיה" },
  { id: 46, name: 'דנמרק' },
  { id: 47, name: "ג'יבוטי" },
  { id: 48, name: 'דומיניקה' },
  { id: 49, name: 'הרפובליקה הדומיניקנית' },
  { id: 50, name: 'מזרח טימור' },
  { id: 51, name: 'אקוודור' },
  { id: 52, name: 'מצרים' },
  { id: 53, name: 'אל סלבדור' },
  { id: 54, name: 'גיניאה המשוונית' },
  { id: 55, name: 'אריתריאה' },
  { id: 56, name: 'אסטוניה' },
  { id: 57, name: 'אתיופיה' },
  { id: 58, name: "פיג'י" },
  { id: 59, name: 'פינלנד' },
  { id: 60, name: 'צרפת' },
  { id: 61, name: 'גאבון' },
  { id: 62, name: 'גמביה' },
  { id: 63, name: 'גאורגיה' },
  { id: 64, name: 'גרמניה' },
  { id: 65, name: 'גאנה' },
  { id: 66, name: 'יוון' },
  { id: 67, name: 'גרנדה' },
  { id: 68, name: 'גואטמלה' },
  { id: 69, name: 'גינאה' },
  { id: 70, name: 'גינאה-ביסאו' },
  { id: 71, name: 'גיאנה' },
  { id: 72, name: 'האיטי' },
  { id: 73, name: 'הונדורס' },
  { id: 74, name: 'הונגריה' },
  { id: 75, name: 'איסלנד' },
  { id: 76, name: 'הודו' },
  { id: 77, name: 'אינדונזיה' },
  { id: 78, name: 'איראן' },
  { id: 79, name: 'עיראק' },
  { id: 80, name: 'אירלנד' },
  { id: 81, name: 'ישראל' },
  { id: 82, name: 'איטליה' },
  { id: 83, name: "ג'מייקה" },
  { id: 84, name: 'יפן' },
  { id: 85, name: 'ירדן' },
  { id: 86, name: 'קזחסטן' },
  { id: 87, name: 'קניה' },
  { id: 88, name: 'קיריבטי' },
  { id: 89, name: 'צפון קוריאה' },
  { id: 90, name: 'דרום קוריאה' },
  { id: 91, name: 'כווית' },
  { id: 92, name: 'קירגיזסטן' },
  { id: 93, name: 'לאוס' },
  { id: 94, name: 'לטביה' },
  { id: 95, name: 'לבנון' },
  { id: 96, name: 'לסוטו' },
  { id: 97, name: 'ליבריה' },
  { id: 98, name: 'לוב' },
  { id: 99, name: 'ליכטנשטיין' },
  { id: 100, name: 'ליטא' },
  { id: 101, name: 'לוקסמבורג' },
  { id: 102, name: 'מקדוניה הצפונית' },
  { id: 103, name: 'מדגסקר' },
  { id: 104, name: 'מלאווי' },
  { id: 105, name: 'מלזיה' },
  { id: 106, name: 'מלדיביים' },
  { id: 107, name: 'מאלי' },
  { id: 108, name: 'מלטה' },
  { id: 109, name: 'איי מרשל' },
  { id: 110, name: 'מאוריטניה' },
  { id: 111, name: 'מאוריציוס' },
  { id: 112, name: 'מקסיקו' },
  { id: 113, name: 'מיקרונזיה' },
  { id: 114, name: 'מולדובה' },
  { id: 115, name: 'מונקו' },
  { id: 116, name: 'מונגוליה' },
  { id: 117, name: 'מונטנגרו' },
  { id: 118, name: 'מרוקו' },
  { id: 119, name: 'מוזמביק' },
  { id: 120, name: 'מיאנמר' },
  { id: 121, name: 'נמיביה' },
  { id: 122, name: 'נאורו' },
  { id: 123, name: 'נפאל' },
  { id: 124, name: 'הולנד' },
  { id: 125, name: 'ניו זילנד' },
  { id: 126, name: 'ניקרגואה' },
  { id: 127, name: "ניז'ר" },
  { id: 128, name: 'ניגריה' },
  { id: 129, name: 'נורווגיה' },
  { id: 130, name: 'עומאן' },
  { id: 131, name: 'פקיסטן' },
  { id: 132, name: 'פלאו' },
  { id: 133, name: 'פנמה' },
  { id: 134, name: 'פפואה גינאה החדשה' },
  { id: 135, name: 'פרגוואי' },
  { id: 136, name: 'פרו' },
  { id: 137, name: 'פיליפינים' },
  { id: 138, name: 'פולין' },
  { id: 139, name: 'פורטוגל' },
  { id: 140, name: 'קטאר' },
  { id: 141, name: 'רומניה' },
  { id: 142, name: 'רוסיה' },
  { id: 143, name: 'רואנדה' },
  { id: 144, name: 'סנט קיטס ונוויס' },
  { id: 145, name: 'סנט לוסיה' },
  { id: 146, name: 'סנט וינסנט והגרנדינים' },
  { id: 147, name: 'סמואה' },
  { id: 148, name: 'סן מרינו' },
  { id: 149, name: 'סאו טומה ופרינסיפה' },
  { id: 150, name: 'ערב הסעודית' },
  { id: 151, name: 'סנגל' },
  { id: 152, name: 'סרביה' },
  { id: 153, name: 'סיישל' },
  { id: 154, name: 'סיירה לאון' },
  { id: 155, name: 'סינגפור' },
  { id: 156, name: 'סלובקיה' },
  { id: 157, name: 'סלובניה' },
  { id: 158, name: 'איי שלמה' },
  { id: 159, name: 'סומליה' },
  { id: 160, name: 'דרום אפריקה' },
  { id: 161, name: 'דרום סודאן' },
  { id: 162, name: 'ספרד' },
  { id: 163, name: 'סרי לנקה' },
  { id: 164, name: 'סודאן' },
  { id: 165, name: 'סורינאם' },
  { id: 166, name: 'סווזילנד' },
  { id: 167, name: 'שוודיה' },
  { id: 168, name: 'שווייץ' },
  { id: 169, name: 'סוריה' },
  { id: 170, name: 'טאיוואן' },
  { id: 171, name: "טג'יקיסטן" },
  { id: 172, name: 'טנזניה' },
  { id: 173, name: 'תאילנד' },
  { id: 174, name: 'טוגו' },
  { id: 175, name: 'טונגה' },
  { id: 176, name: 'טרינידד וטובגו' },
  { id: 177, name: 'תוניסיה' },
  { id: 178, name: 'טורקיה' },
  { id: 179, name: 'טורקמניסטן' },
  { id: 180, name: 'טובאלו' },
  { id: 181, name: 'אוגנדה' },
  { id: 182, name: 'אוקראינה' },
  { id: 183, name: 'איחוד האמירויות הערביות' },
  { id: 184, name: 'בריטניה' },
  { id: 185, name: 'ארצות הברית' },
  { id: 186, name: 'אורוגוואי' },
  { id: 187, name: 'אוזבקיסטן' },
  { id: 188, name: 'ונואטו' },
  { id: 189, name: 'עיר הוותיקן' },
  { id: 190, name: 'ונצואלה' },
  { id: 191, name: 'וייטנאם' },
  { id: 192, name: 'תימן' },
  { id: 193, name: 'זמביה' },
  { id: 194, name: 'זימבבואה' },
];

export const fetchCountriesOperation = async (
  setCountries: (countries: string[]) => any,
) => {
  try {
    const countriesRes = countriesInHebrew.map((item) => item.name);

    setCountries(countriesRes);
  } catch (e) {
    console.error(`fetchCountriesOperation is failed with the error: ${e}`);
  }
};
